module.exports = __webpack_public_path__ + "static/media/close.7a66ba9d.svg";